import { getMethod } from '../common/api';

export const getUpcomingClasses = async () => {
  return getMethod(`/api/dashboard/upcoming-classes`, {});
};
